
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1kjc7_1q6ua_99",
  "root": "awsui_root_1kjc7_1q6ua_117",
  "title": "awsui_title_1kjc7_1q6ua_155",
  "list": "awsui_list_1kjc7_1q6ua_159",
  "marker--dimmed": "awsui_marker--dimmed_1kjc7_1q6ua_208",
  "marker--highlighted": "awsui_marker--highlighted_1kjc7_1q6ua_211"
};
  